export default __webpack_public_path__ + "media/images/images_v2/barbleue-0c68f10fa6cd6a4e3ee4d0c7eb620e9b.png";